<template>
	<div class="article-wrapper">
    <article class="article">
      <div :class=" (datos.descatalogado) ? 'article-thumbnail descatalogadoImg' : 'article-thumbnail'" 
        :style="{ 'background-image': 'url(\''+datos.imagen+'\')' }"
        :title="datos.titulo + ( (datos.edicion) ?  '\n' + datos.edicion : '' ) "
      >
        <span :class="'article-recommended '+badgeType+'-badge'" :title=" $t('Recomendado') " v-if="datos.recomendado == 'S'"></span>
        <a href="#" v-on:click.prevent="showModalFichaExtendida(datos.id, datos.tipo, datos.con)"></a>                                           
      </div>
      <div :class=" 'article-content ' + datos.tipo + '-fb-bottom-line'">
        <div class="article-content-inner">
          <div class="article-title">
            <span class="title-gradient"></span>
            <a href="#" :title="datos.titulo + ( (datos.edicion) ?  '\n' + datos.edicion : '' ) " v-on:click.prevent="showModalFichaExtendida(datos.id, datos.tipo, datos.con)">{{ datos.titulo + ( (datos.edicion) ?  ' · ' + datos.edicion : '' ) }}</a>
          </div>
          <div class="article-author">
            <span class="author-gradient"></span>
            <div class="author">
              <template v-if="datos.tipo == 'S'">
                {{ datos.volumen }} {{ (datos.edicion) ? ' - ' + datos.edicion : '' }}
              </template>
              <template v-else v-for="(autor, index) in autores">
                <template v-if="index > 0">, </template>
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: autor.categoria }, query: autor.query }" :key="index">{{ autor.nombre }}</router-link>
              </template>
            </div>
          </div>
          <div class="article-data">
            <span class="data-gradient"></span>
            <span class="data">
              <template v-if="ano">
                <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: ano.categoria }, query: ano.query }">{{ ano.nombre }}</router-link> -
              </template>
              <router-link v-if="datos.formato" :to="{ name: 'catalogo', params: { language: getLocale, category: datos.formato.categoria }, query: datos.formato.query }">{{ datos.formato.nombre }}</router-link>
            </span>
          </div>
          <div v-if="datos.descatalogado" class="article-selection">
            <span class="descatalogado">{{ datos.descatalogado }}</span>
          </div>
          <div v-else class="article-selection">  
            <span style="float:left;" :class=" datos.tipo + '-color fb-tipo-text uppercase' ">{{ setTipoText(datos.tipo) }}</span>
            <div v-if=" datos.miseleccion == null && getLoggedIn "><img src="@/assets/img/loading-mini.gif" ></div>
            <template v-else>
              <a href="#" class="article-price-selected"
                v-if="datos.miseleccion" 
                v-on:click.prevent="removeFromSelection(datos.id)">{{ toCurrency(datos.precio) }}</a>
              <a href="#" class="article-price" 
                v-else
                v-on:click.prevent="addToSelection( { id: datos.id, ref: 'ficha_basica', tipo: datos.tipo, con: datos.con } )">{{ toCurrency(datos.precio) }}</a> 
            </template>   
          </div>
        </div>                                      
      </div>
    </article>
  </div>
</template>

<i18n>
{
  "es": {
    "Recomendado": "Recomendado",
    "Cine": "Cine",
    "Música":" Música",
    "Libro": "Libro",
    "Serie": "Serie",
    "Documental": "Documental",
    "Juego": "Juego"
  },
  "en": {
    "Recomendado": "Recommended"  
  },
  "ca": {
    "Recomendado": "Recomanat",
    "Cine": "Cinema",
    "Música": "Música",
    "Libro": "Llibre",
    "Serie": "Serie",
    "Documental": "Documental",
    "Juego": "Joc"
  }
}
</i18n>

<script>
  import {mapGetters, mapMutations} from 'vuex';

	export default {
    props:['datos', 'show', 'productID', 'type', 'contenedor'],
		data: () => {
			return{
        autores: [],
        ano: '',
			}
		},
    created(){
      switch(this.datos.tipo){
        case('C'): 
          this.autores = this.datos.directores; 
          this.ano = this.datos.ano; 
          this.badgeType = 'cinema';
          break;
        case('M'): 
          this.autores = (this.datos.compositores) ? this.datos.compositores : this.datos.interpretes ;  
          this.ano = this.datos.ano;
          this.badgeType = 'music';
          break;
        case('L'): 
          this.autores = this.datos.autores;  
          this.ano = this.datos.ano; 
          this.badgeType = 'books';
          break;
        case('S'):
          this.autores = this.datos.directores; 
          this.ano = this.datos.ano; 
          this.badgeType = 'series';
          break;
        case('D'):
          this.autores = this.datos.directores; 
          this.ano = this.datos.ano; 
          this.badgeType = 'documentaries';
          break;
        case('J'): 
          this.autores = this.datos.autores;  
          this.ano = this.datos.ano; 
          this.badgeType = 'games';
          break;
      }
    },
    computed: {
      ...mapGetters(['getApiUrl', 'getLoggedIn', 'getLocale'])
    },
    methods:{
      ...mapMutations(['showModalLogin']),
      addToSelection(obj){
        if( this.getLoggedIn ){
          this.$store.dispatch('addToSelection', obj);
        }else{
          //alert('ShowModalLogin');
          this.$store.commit('showModalLogin');
        }
      },
      removeFromSelection(id){
        if( this.getLoggedIn ){
          this.$store.dispatch('removeFromSelection', id);
        }else{
          //alert('ShowModalLogin');
          this.$store.commit('showModalLogin');
        }
      },
      showModalFichaExtendida(id, tipo, contenedor){
        this.$emit('update:show', true);
        this.$emit('update:productID', id);
        this.$emit('update:type', tipo);
        this.$emit('update:contenedor', contenedor);
      },
      setTipoText(tipo){
        var tmp
        switch(tipo){
          case ('C'): tmp = this.$t('Cine'); break;
          case ('M'): tmp = this.$t('Música'); break;
          case ('L'): tmp = this.$t('Libro'); break;
          case ('S'): tmp = this.$t('Serie'); break;
          case ('D'): tmp = this.$t('Documental'); break;
          case ('J'): tmp = this.$t('Juego'); break;
          default: tmp = ''; break;
        }
        return tmp
      }
    }
  }
</script>
